import React from 'react';
import type { ConsentProfile } from 'types/nhis';
import { DetailContainer, DetailTitle, DetailTable, DetailRow, DetailLabel, DetailValue } from './styles';

/** 동의 1: 일반 개인정보 수집 및 이용 동의 (CONSENT_VERSION 20260423) */
const ConsentDetail1: React.FC<{ profile?: ConsentProfile }> = ({ profile }) => (
  <DetailContainer>
    <DetailTitle $kmrs={profile === 'kmrs'}>일반 개인정보 수집 및 이용 동의</DetailTitle>
    <DetailTable>
      <tbody>
        <DetailRow>
          <DetailLabel>수집 및 이용 목적</DetailLabel>
          <DetailValue>
            <ul>
              <li>서비스 이용을 위한 환자 본인 확인 절차 수행</li>
              <li><strong>공공기관(건강보험심사평가원 등) 투약 이력 조회 대행 및 자동 수집(스크래핑) 연동 프로세스 진행</strong></li>
              <li>담당 약사의 '맞춤형 심층 복약 상담' 사전 준비 지원</li>
            </ul>
          </DetailValue>
        </DetailRow>
        <DetailRow>
          <DetailLabel>수집하는 항목 및 보유 기간</DetailLabel>
          <DetailValue>
            <ul>
              <li><strong>성명</strong> (보관 1년)</li>
              <li><strong>휴대전화번호</strong> (본인확인 및 서비스 연동 완료 후 지체 없이 파기)</li>
              <li><strong>동의 기록</strong> (보관 1년)</li>
            </ul>
            <p className="note">
              ※ 본 항목은 당사([주식회사 약문약답], 서비스명 PhAI) 서버 내의 보유 기간을 의미합니다.
            </p>
          </DetailValue>
        </DetailRow>
        <DetailRow>
          <DetailLabel>동의 거부 권리 및 불이익</DetailLabel>
          <DetailValue>
            귀하는 본 개인정보 수집 및 이용에 대한 동의를 거부할 권리가 있습니다.
            <p className="note">
              ※ 단, 본 항목은 서비스 제공을 위한 필수적 정보이므로, 동의를 거부하실 경우 스크래핑을 통한 투약 이력 연동 및 약사의 심층 상담 서비스를 이용하실 수 없습니다.
            </p>
          </DetailValue>
        </DetailRow>
      </tbody>
    </DetailTable>
  </DetailContainer>
);

export default ConsentDetail1;
